import * as React from "react";
import styles from "./applied_filter.module.sass";

type AppliedFilterProps<T> = {
  filterName: string;
  values: {
    name: string;
    id?: T;
  }[];
  onRemove: (id?: T) => void;
};

export const AppliedFilter = <T extends number | null>({
  filterName,
  values,
  onRemove,
}: AppliedFilterProps<T>): JSX.Element => (
  <div className={styles.appliedFilter}>
    <span className={styles.name} data-testid="filter-chip">
      {filterName}
    </span>
    {values.map((value) => (
      <span
        key={(
          (Array.isArray(value.id) ? value.id.join("_") : value.id) ?? ""
        ).toString()}
        className={styles.value}
        data-testid="filter-value"
      >
        {value.name}
        <button
          type="button"
          title={`Smazat ${value.name}`}
          onClick={() => onRemove(value.id)}
        >
          ╳
        </button>
      </span>
    ))}
  </div>
);
